//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from '@legacy-components/page-layout-simple/page-layout-simple.html';
import '@legacy-components/page-layout-simple/page-layout-simple.less';

angular.module('curalate').component('pageLayoutSimple', {
  transclude: true,
  template,
});
